export enum PcmlNoteCellBlock {
  Root = 'PcmlNoteCell',
}

export enum PcmlNoteCellElement {
  Note = 'note',
}
